import MESSAGES from '../../../../../../../../../appMessages';
import { createExceptionUtils } from '../utils';

const FIELD_VALIDATION_MESSAGES = {
  code: MESSAGES.PROCESS_DELIVERY.EXCEPTION_TYPE_REQUIRED,
  pieces: MESSAGES.PROCESS_DELIVERY.EXCEPTION_PIECES_REQUIRED,
  description: MESSAGES.PROCESS_DELIVERY.EXCEPTION_DESCRIPTION_REQUIRED,
  packageType: MESSAGES.PROCESS_DELIVERY.PACKAGE_TYPE_REQUIRED
};

const VALIDATED_FIELDS = ['code', 'pieces', 'description', 'packageType'];

const validateExceptionField = (name, value) => {
  if (FIELD_VALIDATION_MESSAGES[name]) {
    return value == null || value === '' ? FIELD_VALIDATION_MESSAGES[name] : null;
  }

  return null;
};

const getExceptionDetailsObject = (exceptionDetail = {}) => ({
  code: exceptionDetail.code ?? null,
  pieces: exceptionDetail.pieces ?? null,
  packageType: exceptionDetail.packageType ?? null,
  description: exceptionDetail.description ?? null,
  errorInfo: {
    code: null,
    pieces: null,
    packageType: null,
    description: null
  }
});

export default createExceptionUtils({
  validatedFields: VALIDATED_FIELDS,
  validateExceptionField,
  getExceptionDetailsObject
});
